<script lang="ts">
	import UnderlineLink from './underlineLink.svelte';

	type FooterLinkVariant = 'regular' | 'legal';

	interface Props {
		label?: string | null;
		url: string;
		external: boolean;
		variant?: FooterLinkVariant;
	}

	let { label, url, external, variant = 'regular' }: Props = $props();

	let classes = $derived(
		variant === 'regular'
			? 'text-brown-2 text-[18px]/[140%] font-semibold'
			: 'text-brown-3 text-[12px]/[120%] group-hover:text-brown-2'
	);
</script>

<UnderlineLink {url} {external} class={classes}>
	{label || url}
</UnderlineLink>
